import { computed, observable, reaction } from 'mobx';
import { useEffect, useRef } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import PageSwiperStore from '@src/components/swiper/page-swiper/store';
import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';
// import ComFooterStore from '@src/business-components/common-footer/store';
import ComFooterStore from '@src/business-components/common-footer/store';
import Video from '@src/components/video';
import { noop } from '@src/utils/common-util';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

class WorldViewStore extends BaseStore {
  @observable videoList = [];
  @observable slidesData = [];
  @observable videoIndex = 0;
  @computed
  get videoSrc() {
    return this.videoList[this.videoIndex]?.worldVideo;
  }
  @computed
  get isShowBackTop() {
    return this.pageSwiperStore.baseSwiperStore.activeIndex >= this.slidesData.length - 1;
  }

  pageSwiperStore = new PageSwiperStore({
    effectMode: pageSwiperEffect.NORMAL
  });
  comFooterStore = new ComFooterStore({
    scrollToTop: () => {
      this.backTop();
      this.comFooterStore.isActive = false;
    }
  });

  closeVideoModal = noop; // 关闭视频弹窗
  videoSlideTimer = null; // 视频轮播定时器
  allowSwitchPageSwiperTimer = null; // 允许切换页面定时器

  changeVideo = index => {
    clearInterval(this.videoSlideTimer);
    this.videoIndex = index;
  };

  controlSilentVideo = isPlay => {
    const video = this.videoRef.current;
    if (isPlay) {
      video.play();
    } else {
      video.pause();
    }
  };

  playVideo = () => {
    this.controlSilentVideo(false);
    const { close } = Video.append({
      src: this.videoSrc,
      closeCb: () => {
        this.controlSilentVideo(true);
      }
    });
    this.closeVideoModal = close;
  };

  backTop = () => {
    this.pageSwiperStore.baseSwiperStore.onChange(0);
  };

  playNextSlideVideo = () => {
    this.videoIndex = this.videoIndex + 1;
    if (this.videoIndex === this.videoList.length) {
      this.videoIndex = 0;
    }
  };

  autoplayVideoSlide = () => {
    this.videoSlideTimer = setInterval(() => {
      this.videoIndex = this.videoIndex + 1;
      if (this.videoIndex === this.videoList.length) {
        this.videoIndex = 0;
      }
    }, 5000);
  };

  use() {
    super.use();

    this.videoRef = useRef(null);

    const pageData = useFunLinkPageData();
    useEffect(
      () => {
        if (pageData) {
          this.slidesData = pageData.worldList || [];
          this.videoList = pageData.videoList || [];
        }
      },
      [pageData]
    );

    useMount(() => {
      reaction(
        () => this.pageSwiperStore.baseSwiperStore.activeIndex,
        index => {
          this.closeVideoModal();
          if (index === 2) {
            this.videoRef.current.addEventListener('ended', () => {
              this.playNextSlideVideo();
            });
          } else {
            clearInterval(this.videoSlideTimer);
          }
        }
      );
      reaction(
        () => this.comFooterStore.isActive,
        isActive => {
          clearTimeout(this.allowSwitchPageSwiperTimer);
          // 如果footer已经显示, 则禁止pageSwiper切换
          if (isActive) {
            this.pageSwiperStore.allowSwitch = false;
          } else {
            this.allowSwitchPageSwiperTimer = setTimeout(() => {
              this.pageSwiperStore.allowSwitch = true;
            }, 300);
          }
        }
      );
      const handleScroll = e => {
        /**
         * 如果已经滑动到最后一屏，此时再次滑动鼠标，则可以控制footer是否显示
         */
        if (!this.pageSwiperStore.finalPageTransitionEnd) {
          return;
        }
        this.comFooterStore.isActive = e.deltaY > 0;
      };
      window.addEventListener('wheel', handleScroll);
      return () => {
        clearInterval(this.videoSlideTimer);
        this.closeVideoModal();
        window.removeEventListener('wheel', handleScroll);
      };
    });
  }
}

export default WorldViewStore;
